import React, { Component } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { Section, SectionHeader, Paragraph, BlogSlider } from 'components';
import './Carousel.scss';

import { sliderData } from './logic';

class Carousel extends Component {
  constructor() {
    super();

    this.state = {
      isMobile: false,
    };
  }

  componentDidMount() {
    this.handleResize();

    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth < 768 });
  };

  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            apps: file(relativePath: { eq: "career/career-virgin.png" }) {
              childImageSharp {
                fluid(maxWidth: 1670) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            mobile: file(relativePath: { eq: "career/career-mobile.png" }) {
              childImageSharp {
                fluid(maxWidth: 1670) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            mac: file(relativePath: { eq: "career/career-mac-phone.png" }) {
              childImageSharp {
                fluid(maxWidth: 1670) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            space: file(relativePath: { eq: "career/career-awards.png" }) {
              childImageSharp {
                fluid(maxWidth: 1670) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            appsSmall: file(relativePath: { eq: "career/virgin-mobile.png" }) {
              childImageSharp {
                fluid(maxWidth: 768) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            mobileSmall: file(relativePath: { eq: "career/sonnen-mobile.png" }) {
              childImageSharp {
                fluid(maxWidth: 768) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            macSmall: file(relativePath: { eq: "career/apps-mobile.png" }) {
              childImageSharp {
                fluid(maxWidth: 768) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            spaceSmall: file(relativePath: { eq: "career/awards-mobile.png" }) {
              childImageSharp {
                fluid(maxWidth: 768) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `}
        render={loadedData => (
          <>
            <Section color={'carrara'} additionalClass={'career-match'}>
              <SectionHeader size={'small'} headingType={2} lineColor={'yellow'}>
                Why Boldare is a
                <br />
                match for you?
              </SectionHeader>
              <Paragraph color={'black'} size={'medium'}>
                {
                  'You are about to join the place where +130 creative minds get along well, live and breathe with design and tech, mountain bike, do yoga and travel the world together, but first - work with passion to build stunning digital products!'
                }
              </Paragraph>
              <div className={'career-match--background'} />
            </Section>
            <BlogSlider
              theme={'dark'}
              data={sliderData.map(el => ({
                ...el,
                background: loadedData[this.state.isMobile ? el.background + 'Small' : el.background].childImageSharp.fluid,
              }))}
            />
          </>
        )}
      />
    )
  }
}

export default Carousel;
